import { render, staticRenderFns } from "./FiltersTag.vue?vue&type=template&id=c6aea4e8&"
import script from "./FiltersTag.vue?vue&type=script&lang=js&"
export * from "./FiltersTag.vue?vue&type=script&lang=js&"
import style0 from "./FiltersTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports